import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0960aadc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 2,
  class: "iframe-container rounded-4 border d-flex justify-content-center align-items-center"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph text-muted" }, "Nenhum vídeo", -1))
const _hoisted_5 = [
  _hoisted_4
]

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'YoutubeInput',
  props: {
    readOnly: { type: Boolean, default: false },
    errorMsg: { default: "" },
    label: { default: "" },
    model: { default: () => ({}) },
    value: { default: "" },
    customClasses: { default: "rounded" },
    style: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const youtubeUrlParser = (value: string) => {
  const regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/|shorts\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = value.match(regExp);
  return match && match[7].length == 11
    ? `https://youtube.com/watch?v=${match[7]}`
    : "";
};

const prepareYoutubeLink = (value: string): string | boolean => {
  const parsedUrl = youtubeUrlParser(value);
  const url = parsedUrl.replace("watch?v=", "embed/").split("&")[0];
  if (url != undefined || url != "") {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length == 11) {
      return url;
    }
    return false;
  }
  return false;
};

const videoLink = computed<string | boolean>(() => {
  if (props.model?.$model) {
    return prepareYoutubeLink(props.model.$model);
  }
  if (props.value || props.readOnly) {
    return prepareYoutubeLink(props.value);
  }
  return false;
});

const prepareVideoId = (event: Event) => {
  const value = (event.target as HTMLInputElement).value;
  const parsedUrl = youtubeUrlParser(value);
  const url = parsedUrl.replace("watch?v=", "embed/").split("&")[0];
  props.model.$model = url;
};

return (_ctx: any,_cache: any) => {
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.readOnly)
      ? (_openBlock(), _createBlock(_component_TextInput, {
          key: 0,
          label: _ctx.label,
          model: _ctx.model,
          placeholder: "https://www.youtube.com/watch?v=6iFbuIpe68k&t=7s",
          errorMsg: _ctx.errorMsg,
          onInput: prepareVideoId
        }, null, 8, ["label", "model", "errorMsg"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      (_ctx.readOnly)
        ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      (videoLink.value)
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 1,
            class: _normalizeClass(["iframe-container rounded-4", _ctx.customClasses]),
            width: "100%",
            height: "100%",
            src: videoLink.value as string,
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: "",
            style: _normalizeStyle(_ctx.style)
          }, null, 14, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
    ])
  ], 64))
}
}

})